import axios from './index'
import store from '@/store'
import { cleanParams } from '@/filters'
export const getPakageByPage = (params) => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/pakageRecord', {
    params: cleanParams({ ...params, companyId, teamId, field: 'createTime', order: 'desc' })
  })
}
// 创建下载包
export const addPakage = (params) => {
  const user = store.state.userInfo
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.post('/welldbCombine/pakageRecord', {
    moveToQuery: true,
    params: cleanParams({ ...params, companyId, teamId, createUserId: user.userId })
  })
}

export const updatePakage = (params) => {
  return axios.put('/welldbCombine/pakageRecord', {
    moveToQuery: true,
    params
  })
}
export const deletePakage = (id) => {
  return axios.delete('/welldbCombine/pakageRecord', {
    params: {
      id
    }
  })
}
export const getDownloadByPage = (params) => {
  return axios.get('/welldbCombine/downloadRecord', {
    params: { ...params, field: 'createTime', order: 'desc' }
  })
}
// 创建下载记录
export const addDownloadRecord = (params) => {
  return axios.post('/welldbCombine/downloadRecord', {
    moveToQuery: true,
    params
  })
}

export const deleteDownload = (id) => {
  return axios.delete('/welldbCombine/downloadRecord', {
    params: {
      id
    }
  })
}


export const creatPackageRecord = (data) => {
  // const user = store.state.userInfo
  // const currentRole = store.state.currentRole
  // const { companyId, teamId } = currentRole
  return axios.post('/welldbCombine/api/dataset/creatPackageRecord', {...data})
}